import { jsx as _jsx } from "react/jsx-runtime";
import { useSearchResults } from "@/hooks/useSearchResults";
import { Warning } from "@/components/SearchResults/Warning";
import { TwoPane } from "@/components/cortex";
export var SearchResults = function () {
    var _a = useSearchResults(), loading = _a.loading, error = _a.error, searchData = _a.searchData;
    if (error) {
        return _jsx(Warning, { text: "Error occurred. Try again later" });
    }
    if (loading) {
        return _jsx(Warning, { text: "Loading..." });
    }
    if (!searchData || searchData.jobs.length === 0) {
        return _jsx(Warning, { text: "No jobs right now, check back soon!" });
    }
    return _jsx(TwoPane, { searchData: searchData });
};
